// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2vjzN","header":"styles_header__17gcd","cancelButton":"styles_cancelButton__2RzKV","confirmButton":"styles_confirmButton__3drqZ"};